import React from 'react';
import PropTypes from "prop-types";

const CommonInputTag = React.forwardRef((props = {}, ref) => {
    const {
        onBlur,//click
        onChange,//click
        id = "",
        name = "",
        value = "",
        type = "text",
        className = "",
        placeholder = "", //dynamiv placeHolder "string"
        readOnly = false,
        required = false,
        autoFocus = false,
        errMsg = "",
        maxLength = "",
        onKeyUp,
        onPaste,
        autoComplete=false,
        ...rest
     } = props || {};
    return (
        <React.Fragment>
            <input
                ref={ref}
                formNoValidate
                id={id || ""}
                autoComplete={autoComplete ? "on" : "off"}
                onChange={onChange}
                name={name || ""}
                value={value || ""}
                type={type || "text"}
                onBlur={onBlur || null}
                required={required || ""}
                readOnly={readOnly || false}
                className={className || ""}
                placeholder={placeholder || ""}
                autoFocus={autoFocus === true}
                maxLength= {maxLength || ""}
                onKeyUp={onKeyUp}
                onPaste={onPaste || null}
                {...rest}
            />
            <span className="error">{errMsg || null}</span>
        </React.Fragment>
    );
});
CommonInputTag.propTypes = {
    id: PropTypes.string,
    onBlur: PropTypes.func,
    name: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    placeholder: PropTypes.string,
};

export default React.memo(CommonInputTag);
